module.exports = __webpack_public_path__ + "assets/info-circle-white-985caa.svg";